import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const paymentStatusCode = ['STAKED', 'UNSTAKING', 'UNSTAKED'];
const paymentStatusString = {
  STAKED: '동결',
  UNSTAKING: '해제진행중',
  UNSTAKED: '해제완료',
}
class BbtStaking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.bbtStakingList,[10,pageNum],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };
  unstaking = (idx) => {
    if (global.confirm(idx+'번 동결을 해제하시겠습니까?'))
      httpPost(httpUrl.bbtUnstaking,[idx],{}).then((res) => {
        if (res.data) this.getList();
        else alert("동결해제에 실패하였습니다.")
      });
  };

  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "번호",
        dataIndex: "idx",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "아이디",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "상태",
        dataIndex: "status",
        className: "support-column-number fs-15 lh-21",
        render: data => paymentStatusString[data]
      },
      {
        title: "수량",
        dataIndex: "amount",
        className: "support-column-number fs-15 lh-21",
        render: data => amountFormat(data, 401)
      },
      {
        title: "동결일",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: data => data ? moment(data).format('YYYY-MM-DD') : '-'
      },
      {
        title: "해제요청일",
        dataIndex: "unstakingDate",
        className: "support-column-number fs-15 lh-21",
        render: data => data ? moment(data).format('YYYY-MM-DD') : '-'
      },
      {
        title: "해제완료일",
        dataIndex: "unstakedDate",
        className: "support-column-number fs-15 lh-21",
        render: data => data ? moment(data).format('YYYY-MM-DD') : '-'
      },
      {
        title: "작업",
        dataIndex: "idx",
        className: "support-column-number fs-15 lh-21",
        render: (data,row) => 
        row.status == "STAKED" ? <Button
          onClick={() => {
            this.unstaking(data)
          }}>
          동결해제
        </Button> : ""
      },
    ];
    

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
            
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.status == 'UNSTAKING' ? "blue" : record.status == 'UNSTAKED' ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default BbtStaking;
